import { dataLayer } from '../safe_data_layer'
import { Project, ProjectData } from './types'

export class GtmHelper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static pushProjectImpressions(project: Project, position: number, list: any) {
    const impressionData = {
      event: 'eeProductImpression',
      ecommerce: {
        currencyCode: 'EUR',
        impressions: projectList(project, position, list),
      },
    }
    dataLayer.push(impressionData)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static pushProjectClicks(project: Project, position: number, list: any) {
    const clickData = {
      event: 'eeProductClick',
      ecommerce: {
        click: {
          actionField: { list: list },
          products: projectList(project, position, list),
        },
      },
    }
    dataLayer.push(clickData)
  }

  static pushProductDetailImpression(project: Project) {
    const detailData = {
      event: 'eeProductDetailImpression',
      ecommerce: {
        detail: {
          products: projectList(project),
        },
      },
    }
    dataLayer.push(detailData)
  }

  static pushAddToBasket(project: Project) {
    const basketData = {
      event: 'eeAddToBasket',
      ecommerce: {
        currencyCode: 'EUR',
        add: {
          products: projectList(project, undefined, undefined, 1),
        },
      },
    }
    dataLayer.push(basketData)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function projectList(project: Project, position?: number, list?: any, quantity?: number): [ProjectData] {
  const projectData: ProjectData = { name: project.title ?? '', id: `Project#${project.id}` }
  if (project.carrier) projectData.brand = `Organisation#${project.carrier.id} ${project.carrier.name}`
  if (quantity) projectData.quantity = quantity
  if (position) projectData.position = position
  if (list) projectData.list = list
  return [projectData]
}
